import LegalDocument from '../components/LegalDocument';
import { TERMS } from '../content/legal';

/**
 * The Terms, at /terms.
 *
 * A page rather than a modal, deliberately: a legal document needs its own URL so it can
 * be linked to, bookmarked, cited in an email, and read without dismissing something.
 *
 * The wording is Sidney's and lives in content/legal.ts. See the note at the top of that
 * file for what was transcribed and what was deliberately not published.
 */
export default function Terms() {
  return <LegalDocument document={TERMS} />;
}
